import Serializer from 'umg-ember-backend/serializers/application';

export default class AssetFormatRelationSerializer extends Serializer {
  attrs = {
    assetFormat: 'assetFormatvId',
    asset: 'assetId',
  };
}
